<template>
    <div class="document-container" id="documentManagement">
        <div class="document-list">
            <FolderList :folder="folder" @openFolder="openFolder"></FolderList>
        </div>

        <div class="document-table">
            <div class="document-table-operation">
                <FileOperation @query="queryFile" :folderName="folderName" :files="currentFiles"></FileOperation>
            </div>
            <div class="document-table-content">
                <FileTable :data="currentFiles" @openFile="openFile"></FileTable>
            </div>
        </div>

        <FileDialog :dialogVisible="dialogVisible" :file="theFile" @closeFile="closeFile"></FileDialog>
    </div>
</template>

<script>
    import FolderList from '../../components/EquipmentLedger/document/FolderList';
    import FileOperation from '../../components/EquipmentLedger/document/FileOperation';
    import FileTable from '../../components/EquipmentLedger/document/FileTable';
    import FileDialog from '../../components/EquipmentLedger/document/FileDialog';

    import {
        dateFormat,
    } from "@/util/DateUtil"
    import {
        GetFileAndFolder
    } from '../../api/equipment';
    //支持的格式
    const ALLOW = ['pdf', 'jpg', 'jpeg', 'doc', 'docx', 'png'];

    export default {
        components: {
            FolderList,
            FileOperation,
            FileTable,
            FileDialog
        },
        data() {
            return {
                folder: [],
                filesMap: {},
                files: [],
                theFile: {},
                dialogVisible: false,
                currentFiles: [],
                folderName: ''
            }
        },
        methods: {
            //打开文件夹
            openFolder(folderName) {
                let files = this.filesMap.get(folderName);
                console.log(this.files);
                files = files.sort((a,b) => {
                    console.log(a.time,b.time);
                    let time1 = new Date(a.time).getTime()
                    let time2 = new Date(b.time).getTime()
                    console.log(time1,time2);
                    return time1- time2
                })
                this.files = files
                this.currentFiles = this.files
                this.folderName = folderName
            },
            //打开文件
            openFile(file) {
                this.theFile = file;
                this.dialogVisible = true;
                // console.log(file);
            },
            //关闭文件
            closeFile(file) {
                this.theFile = {};
                this.dialogVisible = false;
            },
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }

                return data;
            },
            //获取文件和文件夹
            async getFileAndFolder(projectId) {
                let result = await GetFileAndFolder(projectId);
                // 你把这个result用对象存,不要用map存试一下
                result = this.transformForData(result);
                console.log(result);

                this.folder = result.list.children.map(item => item.name);
                // console.log(this.folder);
                let map = result.list.children.map(item => {
                    return [item.name, item.children.map(item => {
                        return {
                            // name: item.name.split('.')[0],
                            name: item.name.substring(0,item.name.length - item.remotePath.replace(/.+\./, "").toLowerCase().length -1),
                            path: item.remotePath,
                            type: item.remotePath.replace(/.+\./, "").toLowerCase(),
                            time: dateFormat('YYYY-mm-dd HH:MM:SS', new Date(item.date)),
                        };
                    }).filter(item => ALLOW.includes(item.type))];
                })
                // console.log(map);
                return new Map(map);
            },
            // 查询文件
            queryFile(fileName) {
                this.currentFiles = this.files.filter(item => item.name.includes(fileName))
            },
            async getAll(activeName) {
                this.filesMap = await this.getFileAndFolder(this.projectId);
                console.log(this.filesMap);
                if (activeName) {
                    this.files = this.filesMap.get(activeName)
                    this.folderName = activeName
                } else {
                    this.files = this.filesMap.get(this.folder[0]);
                    this.folderName = this.folder[0]
                }
                this.currentFiles = this.files
            }
        },
        async mounted() {
            this.getAll()
        },
        computed: {
            //获取项目id
            projectId: function () {
                return this.$store.getters.projectId;
            }
        }
    }
</script>

<style lang="less" scoped>
    .document-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .document-list {
            .h(968);
            .w(327);
            background: #fff;
        }

        .document-table {
            .h(968);
            .w(1265);
            background: #fff;
            display: flex;
            flex-direction: column;

            .document-table-operation {
                .h(96);
                width: 100%;
                display: flex;
            }

            .document-table-content {
                .h(872);
                flex: 1;
            }
        }
    }
</style>